import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GetProjectIdService {
  private projectIdSubject = new BehaviorSubject<string | null>(null);
  projectId$ = this.projectIdSubject.asObservable(); // Observable for components to subscribe

  setProjectId(id): void {
    this.projectIdSubject.next(id); // Update the BehaviorSubject
    localStorage.setItem('projectId', id); // Persist in localStorage
  }

  getProjectId(): string | null {
    return localStorage.getItem('projectId');
  }

  getProjectServiceId(): string | null {
    return this.projectIdSubject.getValue(); // Get the current value
  }
  getProjectIdFromLocalStorage(): string | null {
    const projectId = localStorage.getItem('projectId');
    return projectId;
  }
}
